<template>
  <modal>
    <div class="card card--white">
      <div class="card--container">
        <h3>
          Please fill out the form below to see your assessment results and recommendations
        </h3>
        <form @submit.prevent="save" class="small-top">
          <h-input v-model="user.first_name" label="First Name" required  outline/>
          <h-input v-model="user.last_name" label="Last Name" required outline />
          <h-input v-model="user.email" label="Email" required outline type="email" />
          <v-alert type="error" :value="error">{{error}}</v-alert>
          <v-alert type="error" :value="displayError">{{displayError}}</v-alert>
          <button class="btn btn--full small-top" type="submit">Submit</button>
          <div class="info-txt">After signing up, you will receive your results and may receive occasional content related to your results via email.</div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import modal from "@/components/modal";
export default {
  components: { modal },
  props: ["error"],
  data() {
    return {
      user: {},
      displayError: "",
      tos: false
    };
  },
  methods: {
    save() {
      this.displayError = false;
      if (!this.user.first_name.trim()) {
        this.displayError = "First name is required";
        return;
      }
      if (!this.user.last_name.trim()) {
        this.displayError = "Last name is required";
        return;
      }

      if (!this.user.email.trim()) {
        this.displayError = "Email is required";
        return;
      }
      this.$emit("save", this.user);
    }
  }
};
</script>

<style lang="less" scoped>
h3 {
  font-size: 24px;
  font-weight: 300;
  color: #70a4ff;
};
</style>
